import {FormControlType, ValidationRules, IFormConfig} from "educat-common-web";

export const calendarFormConfig: typeof IFormConfig = (availableDates: any[] = [], availableTimeSlots: any[] | null = []) => ({
  controlType: 'form',
  class: 'month-timeslots-form',
  dataAccessor: (data: any) => data, // data is not grouped
  outputDataMapper: (data: any, previousStateSnapshot: any) => {
    Object.assign(previousStateSnapshot, data);

    return previousStateSnapshot;
  },
  controls: [
    {
      controlType: 'group',
      key: 'date',
      class: 'form-row',
      controls: {
        date: {
          hostClass: 'col-100 month-calendar',
          controlType: 'control',
          defaultValue: null,
          placeholder: '',
          formControlType: FormControlType.CALENDAR,
          isLabelHidden: true,
          checkboxSlots: true,
          isDateFiltered: false,
          validationRules: [
            { name: ValidationRules.IS_REQUIRED },
          ],
          availableDates: availableDates,
          availableTimeSlots: availableTimeSlots,
          disablePassedHours: true,
          allowSameDay: true
        }
      }
    },
  ]
});
